
import React from 'react';
import NavigationBar from "@navbar/navigation-bar.navbar";
import {BrowserRouter, Outlet, Route, Routes} from "react-router-dom";
import Footer from "@footer/footer.layout";
import Home2 from "@pages/home2.page";
import Map from "@pages/map.page";
import ContactPage from "@pages/contact.page";
import SurveysListPage from "@pages/surveys-list.page";
import SurveyPage from "@pages/survey.page";
import FaqPage from "@pages/faq.page";
import VLDCampaign2026 from "@pages/vld-2026.page";
import PublishListPage from "@pages/publish-list.page";
import NewsPage from "@pages/news.page";
import PublishList2026Page from "@pages/publish-list-2026.page";
import ScrollToTop from "@utils/scroll-to-top.utils";
import DonatePage from "@pages/donate.page";
import CampaignPage from "@pages/campaign.page";
import {usePageTracking} from "./hooks/usePageTracking";
// publication
import POST20250411 from "./contents/posts/2025-04-11";
import POST20250404 from "./contents/posts/2025-04-04";
import POST20240824 from "./contents/posts/2024-08-24";
import POST20240626 from "./contents/posts/2024-06-26";
import POST20240625 from "./contents/posts/2024-06-25";
import POST20240618 from "./contents/posts/2024-06-18";
import POST20240606 from "./contents/posts/2024-06-06";
import POST20240415 from "./contents/posts/2024-04-15";
import POST20240320 from "./contents/posts/2024-03-20";
import POST20240117 from "./contents/posts/2024-01-17";
import POST20231219 from "./contents/posts/2023-12-19";
import POST20231203 from "./contents/posts/2023-12-03";
import POST20231108 from "./contents/posts/2023-11-08";
import POST20231103 from "./contents/posts/2023-11-03";
import POST20230916 from "./contents/posts/2023-09-16";
import POST20230915 from "./contents/posts/2023-09-15";
import POST20230706 from "./contents/posts/2023-07-06";
import POST20250615 from "./contents/posts-2026/2025-06-15";
import POST20251009 from "./contents/posts-2026/2025-10-09";
import ARTICLE20250411 from "./contents/articles/2025-04-11";
import ARTICLE20250621 from "./contents/articles/2025-06-21";
import ARTICLE20250827 from "./contents/articles/2025-08-27";
import ARTICLE20250909 from "./contents/articles/2025-09-09";
import ARTICLE20251009 from "./contents/articles/2025-10-09";
import ARTICLE20251031 from "./contents/articles/2025-10-31";
import POST20251121 from "./contents/posts-2026/2025-11-21";
import POST20251230 from "./contents/posts-2026/2025-12-30";
import POST20260114 from "./contents/posts-2026/2026-01-14";
import POST20260214 from "./contents/posts-2026/2026-02-14";
import POST20260222 from "./contents/posts-2026/2026-02-22";
import POST20260306 from "./contents/posts-2026/2026-03-06";
import POST20260316 from "./contents/posts-2026/2026-03-16";

function LayoutWithNav() {
    return (
        <>
            <NavigationBar />
            <div style={{ paddingTop: "85px"}}>
                <Outlet />
            </div>
            <Footer />
        </>
    );
}

// Nouveau composant qui contient les routes ET le tracking
function AppRoutes() {
    usePageTracking(); // ← Maintenant il est DANS le BrowserRouter

    return (
        <>
            <ScrollToTop />
            <Routes>
                <Route element={<LayoutWithNav />}>
                    <Route path="/" element={<Home2/>} />
                    <Route path="/faq" element={<FaqPage/>} />
                    <Route path="/carte-interactive" element={<Map/>} />
                    <Route path="/contactez-nous" element={<ContactPage />} />
                    <Route path="/vld-2026" element={<VLDCampaign2026 />} />
                    <Route path="/vld-2026/programme" element={<CampaignPage />} />
                    <Route path="/vld-2026/faire-un-don" element={<DonatePage />} />
                    {/* Enquêtes */}
                    <Route path="/les-enquetes" element={<SurveysListPage />} />
                    <Route path="/enquete/:id" element={<SurveyPage />} />
                    {/* Publications 2026 */}
                    <Route path="/vld-2026/les-publications" element={<PublishList2026Page />} />
                    <Route path="/vld-2026/publication/2025-06-15" element={<POST20250615/>} />
                    <Route path="/vld-2026/publication/2025-10-09" element={<POST20251009/>} />
                    <Route path="/vld-2026/publication/2025-11-21" element={<POST20251121/>} />
                    <Route path="/vld-2026/publication/2025-12-30" element={<POST20251230/>} />
                    <Route path="/vld-2026/publication/2026-01-14" element={<POST20260114/>} />
                    <Route path="/vld-2026/publication/2026-02-14" element={<POST20260214/>} />
                    <Route path="/vld-2026/publication/2026-02-22" element={<POST20260222/>} />
                    <Route path="/vld-2026/publication/2026-03-06" element={<POST20260306/>} />
                    <Route path="/vld-2026/publication/2026-03-16" element={<POST20260316/>} />
                    {/* Publications */}
                    <Route path="/les-publications" element={<PublishListPage />} />
                    <Route path="/publication/2025-04-11" element={<POST20250411/>} />
                    <Route path="/publication/2025-04-04" element={<POST20250404/>} />
                    <Route path="/publication/2024-08-24" element={<POST20240824/>} />
                    <Route path="/publication/2024-06-26" element={<POST20240626/>} />
                    <Route path="/publication/2024-06-25" element={<POST20240625/>} />
                    <Route path="/publication/2024-06-18" element={<POST20240618/>} />
                    <Route path="/publication/2024-06-06" element={<POST20240606/>} />
                    <Route path="/publication/2024-04-15" element={<POST20240415/>} />
                    <Route path="/publication/2024-03-20" element={<POST20240320/>} />
                    <Route path="/publication/2024-01-17" element={<POST20240117/>} />
                    <Route path="/publication/2023-12-19" element={<POST20231219/>} />
                    <Route path="/publication/2023-12-03" element={<POST20231203/>} />
                    <Route path="/publication/2023-11-08" element={<POST20231108/>} />
                    <Route path="/publication/2023-11-03" element={<POST20231103/>} />
                    <Route path="/publication/2023-09-16" element={<POST20230916/>} />
                    <Route path="/publication/2023-09-15" element={<POST20230915/>} />
                    <Route path="/publication/2023-07-06" element={<POST20230706/>} />
                    {/* Actualités */}
                    <Route path="/les-actualites" element={<NewsPage/>} />
                    <Route path="/article/2025-04-11" element={<ARTICLE20250411/>} />
                    <Route path="/article/2025-06-21" element={<ARTICLE20250621/>} />
                    <Route path="/article/2025-08-27" element={<ARTICLE20250827/>} />
                    <Route path="/article/2025-09-09" element={<ARTICLE20250909/>} />
                    <Route path="/article/2025-10-09" element={<ARTICLE20251009/>} />
                    <Route path="/article/2025-10-31" element={<ARTICLE20251031/>} />
                </Route>
            </Routes>
        </>
    );
}

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AppRoutes />
            </BrowserRouter>
        </div>
    );
}

export default App;
